import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=2eddb4ad&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=2eddb4ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eddb4ad",
  null
  
)

export default component.exports